export enum DiscountType {
  discount_code = "discount_code",
  referral_code = "referral_code",
  credits = "credits",
  bundle = "bundle",
  generated_price_discount = "generated_price_discount",
  set = "set",
}
